import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
import { ARTIFACT_CONTROLS } from "./constants";

/**
 * The access pane before its keys arrive.
 *
 * It is the pane's own row, bar for bar: the change gutter, the group name,
 * the sheet count, the people count, the note. It lives here rather than in a
 * shared skeleton component because a generic one drifts the moment this row
 * changes, and a row of evenly spaced pills is not what any of these panes
 * actually look like.
 */
const COLUMNS = ["w-3", "w-56", "w-16", "w-16", "w-40"];

export const RulesAccessSkeleton = () => (
  <section
    className="flex min-h-0 flex-1 flex-col"
    role="status"
    aria-label="Loading who can read what…"
  >
    <div
      className={cn(ARTIFACT_CONTROLS, "flex items-center gap-3")}
      aria-hidden
    >
      <Skeleton className="h-3 w-28" />
      <Skeleton className="h-3 w-52" />
    </div>
    {/* More rows than the pane is tall, clipped at the foot, so the edge reads
        as a list that carries on rather than one that stops short. */}
    <div aria-hidden className="min-h-0 flex-1 overflow-hidden">
      {Array.from({ length: 30 }, (_, row) => (
        <Stack
          gap="none"
          align="stretch"
          direction="row"
          key={row}
          className="flex items-center gap-3 border-b border-stroke-tertiary py-2 pl-1 pr-3"
        >
          {COLUMNS.map((width, index) => (
            <Skeleton key={index} className={cn("h-3 shrink-0", width)} />
          ))}
        </Stack>
      ))}
    </div>
  </section>
);
